import { LOCATION_CHANGE } from './location'

export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM'

export const updateSearchTerm = term => ({
    type: UPDATE_SEARCH_TERM,
    searchTerm: term
  })

function searchTerm(state, action = {}) {
  const currentState = state === undefined ? '' : state

  switch (action.type) {
    case UPDATE_SEARCH_TERM:
      return action.searchTerm
    case LOCATION_CHANGE:
      return ''
    default:
      return currentState
  }
}

export default searchTerm
